"use client";

import { useEffect } from "react";
import { useAccount } from "@getpara/react-sdk";

export function BodyScrollReset() {
  const { isConnected } = useAccount();

  useEffect(() => {
    // When connection state changes (e.g. after OTP login modal closes),
    // reset any body scroll lock that Para SDK may have left behind
    const reset = () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.documentElement.style.overflow = "";
    };

    // Small delay to let Para modal finish its own cleanup first
    const timer = setTimeout(reset, 100);
    return () => clearTimeout(timer);
  }, [isConnected]);

  return null;
}
